import { AIContextSchema, AIContextState, AIResultContext } from './state'
import { ActionType, AddAIContext, AIContextActions, RemoveAIContext, ResetAIResultContext, SetAIContextSchema, SetAIFeatureIdInEdit } from './actions'
import { AIResultDisplayModel } from '../AIResultMapper'

export function aiContextReducer(state: AIContextState, action: AIContextActions): AIContextState {
  switch (action.type) {
    case ActionType.ADD_AI_CONTEXT:
      return { ...state, selectedResults: [...state.selectedResults, action.payload] }
    case ActionType.SET_AI_FEATURE_ID_IN_EDIT:
      return { ...state, aiFeatureIdInEdit: action.payload }
    case ActionType.SET_CONTEXT_SCHEMA:
      return {
        ...state,
        aiContextSchemas: { ...state.aiContextSchemas, [action.payload.aiFeatureId]: action.payload.schema },
      }
    case ActionType.REMOVE_AI_CONTEXT:
      return {
        ...state,
        selectedResults: state.selectedResults?.filter((result: AIResultContext) => result.id !== action.payload.id),
      }
    case ActionType.RESET_AI_RESULT_CONTEXT:
      return {
        ...state,
        selectedResults: [],
      }
    default:
      return state
  }
}

export const mapToResult = (result: AIResultDisplayModel | AIResultDisplayModel[]): any => {
  if (Array.isArray(result)) {
    return result.map((r) => {
      return mapToResult(r)
    })
  }

  if (typeof result.result === 'object') {
    return Object.entries(result.result).map(([key, value]) => {
      return { [key]: mapToResult(value) }
    })[0]
  }

  return {
    id: result.displayId,
    aiResult: result.result as string,
  }
}

export const addAIContext = (payload: AIResultDisplayModel): AddAIContext => ({
  type: ActionType.ADD_AI_CONTEXT,
  payload: { id: payload.displayId, aiResult: mapToResult(payload) },
})

export const removeAIContext = (id: string): RemoveAIContext => ({
  type: ActionType.REMOVE_AI_CONTEXT,
  payload: { id },
})

export const setAIFeatureIdInEdit = (id: string | null): SetAIFeatureIdInEdit => ({
  type: ActionType.SET_AI_FEATURE_ID_IN_EDIT,
  payload: id,
})

export const setAIContextSchema = (aiFeatureId: string, schema: AIContextSchema): SetAIContextSchema => ({
  type: ActionType.SET_CONTEXT_SCHEMA,
  payload: { aiFeatureId, schema },
})
export const resetAIContextResult = (): ResetAIResultContext => ({
  type: ActionType.RESET_AI_RESULT_CONTEXT,
})
